<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Noticias</h5>
                <hr>
				<DataTable :value="mensagens" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-between">	
                                <div>
                                    <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
                                    :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR" @date-select="listar"/>
                                </div>			
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="titulo" header="Título">
                        <template #body="slotProps">
                            <label v-if="slotProps.data.atual" class="p-text-bold">
                                {{ slotProps.data.titulo }}
                            </label>
                            <label v-else>
                                {{ slotProps.data.titulo }}
                            </label>
                        </template>
                    </Column>
					<Column field="dataPublicacao" header="Publicação">
                        <template #body="slotProps">                            
                            <label v-if="slotProps.data.atual" class="p-text-bold">
                                {{ formatarStringData(slotProps.data.dataPublicacao) }}
                            </label>
                            <label v-else>
                                {{ formatarStringData(slotProps.data.dataPublicacao) }}
                            </label>
                        </template>
                    </Column>				
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-eye" title="Visualizar" 
                                class="p-button-rounded p-button-primary p-mr-2" @click="visualizarMensagem(slotProps.data)"/>							
						</template>
					</Column>
				</DataTable>			

				<Dialog :visible.sync="exibirDialogView" header="Notícia" :modal="true" :style="{width: '60vw'}">
					<ScrollPanel style="width: 100%; height: 250px" class="custom">
                        <div v-html="texto"></div>
                    </ScrollPanel>
					<template #footer>
						<Button label="OK" icon="pi pi-check" class="p-button-primary" @click="exibirDialogView=false" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>
</template>

<script>
import MensagemService from '@/service/MensagemService.js';
import { exibirMensagem, localeCalendarBR} from '@/global';

export default {
	mensagemService: null,
	data() {
		return {
            exibirDialogView: false,
			mensagens: [],
            mesAno: new Date(),	
            rangeData: '',
            localeCalendarBR: localeCalendarBR,
            texto: '',
			filtro: {}
		}
	},
	methods: {	
        /**
         * 
         */		
		listar() {					
            let hoje = this.formatarData(new Date())
			this.mensagemService.listar(this.mesAno.getFullYear(), (this.mesAno.getMonth()+1))
            .then(resp => {
                this.mensagens = resp.data;
                this.mensagens.forEach(men => {
                    if(men.dataPublicacao == hoje) {
                        men['atual'] = true;
                    }
                });
            })
            .catch(erro => {exibirMensagem(this, erro)});   
		},
        /**
         * 
         */
        visualizarMensagem(mensagem) {
            this.texto = '<h2>'+mensagem.titulo+'</h2>';				
            let textoFormatado = mensagem.conteudo;
            textoFormatado = textoFormatado.replace(/@p/g, '<p style="font-size: 15px">');
            textoFormatado = textoFormatado.replace(/@ep/g, '</p>');
            textoFormatado = textoFormatado.replace(/@b/g, '<strong>');
            textoFormatado = textoFormatado.replace(/@eb/g, '</strong>');				
            this.texto += textoFormatado;
            this.exibirDialogView = true;
        },
        /**
         * 
         */
        formatarStringData(data) {  
            if(!data || data instanceof Date) {
                return '';
            }        
			let partes = data.split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0];
		},
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-5)+':'+(anoAtual+1);     
        },   		
	},
	created() {
		this.mensagemService = new MensagemService();		
        this.criarRangeData();
	},
    mounted() {
        this.listar();
    }
}
</script>

<style>
    .custom .p-scrollpanel-wrapper {
        border-right: 9px solid #f4f4f4;
    }

    .custom .p-scrollpanel-bar {
        background-color: #1976d2;
        opacity: 1;
        transition: background-color .3s;
    }

    .custom .p-scrollpanel-bar:hover {
        background-color: #135ba1;
    }
</style>